var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.LayoutGrid,{attrs:{"layout":_setup.tableViewLayout},scopedSlots:_vm._u([{key:"widget-0",fn:function(){return [_c(_setup.WidgetContainer,{attrs:{"widgetDefinition":_setup.bendProductionHistoryWidgetDefinition,"autorefresh":false}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }